module.exports = __webpack_public_path__ + "static/media/share_finish.107c89d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share_finish.png
// module id = 473
// module chunks = 0